/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedSidebarFavorites_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarFavorites_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FavoritesProvider_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
